import React, { useState } from 'react';
import './index.css';
import { CloseOutlined } from '@ant-design/icons';
import {
  TextInputWrapper,
  TextInputDiv,
  TextInput,
  ErrorDiv,
  LabelDiv,
  Label,
  EyeIcon,
  EyeSlashIcon,
  OuterWrongImage,
  OuterRightImage,
  StyledDiv,
  CloseDynamicField,
  StyledInput,
  StyledSpan
} from './StyledComponents';
import right from '../../assets/images/right.png';
import wrong from '../../assets/images/wrong.png';

const InputBox = props => {

  const {
    errorMessage,
    isRequired,
    autoFocus,
    type,
    placeholder,
    FieldPath,
    onKeyHit,
    onKeyPress,
    name,
    value,
    label,
    onInputChange,
    onBlur,
    touched,
    id,
    width,
    disabled,
    noBorderValidation,
    isHide,
    noMargin,
    min,
    removeField,
    max,
    height,
    mTop,
    refArrValue,
    isArtifact,
    isFullWidth,
    isBorder
  } = props;

  const [viewOn, setViewOn] = useState(false);
  const checkBorder = async elementID => {
    if (errorMessage) {
      document.getElementById(elementID).className = 'errorInput';
    }
    if (!errorMessage) {
      document.getElementById(elementID).className = 'noErrorInput';
    }
  };
  const handleView = () => {
    const x = document.getElementById(id);
    if (x.type === 'password') {
      x.type = 'text';
      setViewOn(true);
    } else {
      x.type = 'password';
      setViewOn(false);
    }
  };
  const onChange = e => {
    if (type === 'number') {
      const val = e.target.value;
      if (val !== '' && parseFloat(val) >= 0) {
        onInputChange(e);
      } else {
        e.target.value = '';
        onInputChange(e);
      }
      return;
    }
    onInputChange(e);
    if (noBorderValidation !== true) {
      checkBorder(e.target.id);
    }
  };

  const onRemoveField = e => {
    removeField(name);
  };

  let minNumber;
  if (type === 'number') {
    minNumber = 0;
  }

  function renderData() {
    let renderItems = (
      <StyledDiv className={disabled ? 'disabled-ip' : ''} isBorder={isBorder} isFullWidth={isFullWidth}>
        <TextInputWrapper type={type} width={width} noMargin={noMargin} mTop={mTop}>
          {label ? (
            <LabelDiv>
              <Label>{label} {isRequired && <StyledSpan> * </StyledSpan>}</Label>
            </LabelDiv>
          ) : null}
          <TextInputDiv height={height}>
            {type === 'password' ? (
              <TextInput
                id={id}
                type={type}
                placeholder={placeholder}
                name={name}
                min={min || minNumber}
                value={value ?? ''}
                max={max}
                onChange={onChange}
                onKeyDown={onKeyHit}
                onBlur={onBlur}
                disabled={disabled}
                ref={refArrValue}
              ></TextInput>
            ) : isArtifact == true ? (
              <StyledInput
                value={value ?? ''}
                placeholder={placeholder}
                onChange={onChange}
              />
            )

              : (
                <TextInput
                  id={id}
                  type={type}
                  placeholder={placeholder}
                  min={min}
                  name={name}
                  max={max}
                  value={value ?? ''}
                  onChange={onChange}
                  onKeyDown={onKeyHit}
                  onKeyPress={onKeyPress}
                  onBlur={onBlur}
                  disabled={disabled}
                  autoFocus={autoFocus ? autoFocus : false}
                  min={min}
                  ref={refArrValue}
                ></TextInput>
              )}

            {type === 'password' && value && !viewOn ? (
              <EyeIcon onClick={handleView} />
            ) : null}
            {viewOn ? <EyeSlashIcon onClick={handleView} /> : null}

            {!noBorderValidation ? (
              value && !errorMessage && !FieldPath ? (
                <OuterRightImage src={right} />
              ) : null
            ) : null}
            {!noBorderValidation ? (
              value && errorMessage && !FieldPath ? (
                <OuterWrongImage src={wrong} />
              ) : null
            ) : null}

            {type === 'dynamicField' ? (
              <CloseDynamicField onClick={onRemoveField}>
                <CloseOutlined />{' '}
              </CloseDynamicField>
            ) : null}
          </TextInputDiv>
        </TextInputWrapper>
        {touched && errorMessage ? <ErrorDiv>{errorMessage}</ErrorDiv> : null}
      </StyledDiv>
    );

    if (isHide === true) {
      renderItems = <></>;
    }

    return renderItems;
  }

  return <>{renderData()}</>;
};

export default InputBox;
